export class HiperCard {

    public static isHiperCard(card: string): boolean {
        return card.replace(/\D+/g,'').length === 16 && /(606282\d{10}(\d{3})?)|(3841\d{15})/.test(card)
    }

}